import { useContext, useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import LeftSidePopupLayout from "../../../../component/popup/modal-layout";
import XCloseIcon from "../../../../component/icons/x-close";
import Style from "./style.module.css";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import { XIcon } from "lucide-react";
import { GlobalContext } from "../../../../context/Context";
import { Alert, Snackbar } from "@mui/material";
import AddUpdateBrand from "../add-brand";
import AddUpdateMerchant from "../add-merchant";
import AddUpdatePackage from "../add-package";
import AddUpdateProduct from "../add-product";
import AddUpdateSubProduct from "../add-subProduct";
import AddUpdateMerchantType from "../add-merchant-type";
import AddUpdateTeam from "../add-team";
import AddUpdateTeamUsers from "../add-team-users";
import AddStatus from "../add-status";

const CompanySettingAddUpdate = ({
  open = null,
  onClose = () => { },
  data = {},
  onChange = () => { },
  tabIndex = 0,
  onError = () => { },
  onSubmit = () => { },
  contactId = {},
  onDealUpdated = () => { }, // refresh after update,
  type = "",
}) => {
  const apiCall = useApiCall();

  let { state, dispatch } = useContext(GlobalContext);

  const [navIndex, setNavIndex] = useState(tabIndex || 0);
  const [noticeType, setNoticeType] = useState([]);
  const [alertData, setAlertData] = useState({ isShow: false });

  const [PackageList, setPackageList] = useState([]);
  const [DealStages, setDealStages] = useState([]);
  const [usersList, setUsers] = useState([]);
  const [country, setCountry] = useState([]);
  const [brands, setBrands] = useState([]);
  const [entityData, setEntityData] = useState([]);
  const [hasMoreClients, setHasMoreClients] = useState(true);
  const [isLoadingClients, setIsLoadingClients] = useState(false);
  const [Clients, setClients] = useState([]);
  const [page, setPage] = useState(1);

  // useEffect(() => {
  //   setPackageList(state?.ModalData?.data?.PackageList);
  //   setDealStages(state?.ModalData?.data?.DealStages);
  //   setUsers(state?.ModalData?.data?.UsersList);
  //   setCountry(state?.ModalData?.data?.Countries);
  //   setBrands(state?.ModalData?.data?.BrandList);

  //   console.log("Modal Data ", state?.ModalData.data);

  // },[])

  // const Countries = async () => {
  //   try {
  //     const res = await apiCall({
  //       method: "get",
  //       url: `location/get-countries`,
  //     });
  //     setCountry(res?.data);
  //   } catch (error) {
  //     console.warn("Error : ", error);
  //   }
  // };

  // const fetchUsers = async () => {
  //   try {
  //     const res = await apiCall({
  //       method: "get",
  //       url: `users/agents-list`,
  //     });

  //     console.log("Users API Response ===>", res);
  //     const newUsers = res?.agents || res?.customers || res?.data || [];
  //     setUsers(newUsers);
  //   } catch (err) {
  //     console.error("Error fetching users", err);
  //   } finally {
  //   }
  // };

  // const getBrands = async () => {
  //   try {
  //     const res = await apiCall({
  //       method: "get",
  //       url: "brands/brands-list?is_paginate=0",
  //     });

  //     setBrands(res?.data || []);
  //   } catch (error) {
  //     console.warn("Error fetching brands:", error);
  //   }
  // };

  // const DealPackage = async () => {
  //   try {
  //     const res = await apiCall({
  //       method: "get",
  //       url: `brands/brand-packages-list?is_paginate=0`,
  //     });

  //     setPackageList(res.data);
  //   } catch (error) {
  //     console.warn("Error : ", error);
  //   }
  // };

  // const DealStage = async () => {
  //   try {
  //     const res = await apiCall({
  //       method: "get",
  //       url: `dealstages/deal-stages-list`,
  //     });

  //     // filter out "Won" and "Lost"
  //     const filteredStages = res.data.filter(
  //       (stage) => stage.name !== "Won" && stage.name !== "Lost"
  //     );

  //     setDealStages(filteredStages);
  //   } catch (error) {
  //     console.warn("Error : ", error);
  //   }
  // };

  // const fetchEntities = async (search = "") => {
  //   try {
  //     const res = await apiCall({
  //       method: "get",
  //       url: `activities/get-activity-type?search=${encodeURIComponent(
  //         search
  //       )}`,
  //     });

  //     const list = res?.data || []; // 👈 safe access to data array

  //     setEntityData(
  //       list.map((item) => ({
  //         id: item.id,
  //         name: item.name,
  //         type: item.type,
  //       }))
  //     );
  //   } catch (error) {
  //     console.error("Error fetching entities:", error);
  //   }
  // };

  // const loadClients = async (pageNum = 1, search = "") => {
  //   // agar search active hai to hamesha page 1 hi chalega
  //   if (search && pageNum > 1) return;

  //   if (isLoadingClients || (!hasMoreClients && pageNum !== 1)) return;

  //   if (pageNum === 1) {
  //     setHasMoreClients(true);
  //     setPage(1);
  //   }

  //   setIsLoadingClients(true);

  //   try {
  //     const url = search
  //       ? `users/customers-list?search=${encodeURIComponent(search)}`
  //       : `users/customers-list?page=${pageNum}`;

  //     const res = await apiCall({ method: "get", url });
  //     const newClients = res?.customers || [];

  //     if (pageNum === 1) {
  //       setClients(newClients);
  //     } else if (newClients.length === 0) {
  //       setHasMoreClients(false);
  //     } else {
  //       setClients((prev) => [...prev, ...newClients]);
  //     }

  //     setPage(pageNum);
  //   } catch (err) {
  //     console.error("Error fetching users", err);
  //   } finally {
  //     setIsLoadingClients(false);
  //   }
  // };

  // useEffect(() => {
  //   Countries();
  //   fetchUsers();
  //   getBrands();
  //   DealPackage();
  //   DealStage();
  //   fetchEntities();
  //   loadClients();
  // }, []);

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  return (
    <div className={Style.modal_body}>
      {/* popupStatus */}
      <LeftSidePopupLayout
        popupStatus={true}
        className={Style.departmentChangeModal}
      >
        <div className={Style.modal_header}>
          <div className={Style.modal_nav}>
            <ul>
              {(data?.brandsid ||
                data?.packageid ||
                data?.id ||
                data?.team_id) &&
                navIndex !== 0 ? null : (
                <li
                  className={navIndex === 0 ? Style.active : null}
                  onClick={() => {
                    setNavIndex(0);
                  }}
                >
                  <div className={Style.icon}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="12"
                      viewBox="0 0 13 12"
                      fill="none"
                    >
                      <path
                        d="M11.8036 4.92857H8.16071C8.04238 4.92857 7.94643 4.83262 7.94643 4.71429V1.07143C7.94643 0.479736 7.46669 0 6.875 0C6.28331 0 5.80357 0.479736 5.80357 1.07143V4.71429C5.80357 4.83262 5.70762 4.92857 5.58929 4.92857H1.94643C1.35474 4.92857 0.875 5.40831 0.875 6C0.875 6.59169 1.35474 7.07143 1.94643 7.07143H5.58929C5.70762 7.07143 5.80357 7.16738 5.80357 7.28571V10.9286C5.80357 11.5203 6.28331 12 6.875 12C7.46669 12 7.94643 11.5203 7.94643 10.9286V7.28571C7.94643 7.16738 8.04238 7.07143 8.16071 7.07143H11.8036C12.3953 7.07143 12.875 6.59169 12.875 6C12.875 5.40831 12.3953 4.92857 11.8036 4.92857Z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                  <span>{data?.brandsid ? "" : "Add"} Brand</span>
                </li>
              )}

              {(data?.brandsid ||
                data?.packageid ||
                data?.id ||
                data?.team_id) &&
                navIndex !== 1 ? null : (
                <li
                  className={navIndex === 1 ? Style.active : null}
                  onClick={() => {
                    setNavIndex(1);
                  }}
                >
                  <div className={Style.icon}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="12"
                      viewBox="0 0 13 12"
                      fill="none"
                    >
                      <path
                        d="M11.8036 4.92857H8.16071C8.04238 4.92857 7.94643 4.83262 7.94643 4.71429V1.07143C7.94643 0.479736 7.46669 0 6.875 0C6.28331 0 5.80357 0.479736 5.80357 1.07143V4.71429C5.80357 4.83262 5.70762 4.92857 5.58929 4.92857H1.94643C1.35474 4.92857 0.875 5.40831 0.875 6C0.875 6.59169 1.35474 7.07143 1.94643 7.07143H5.58929C5.70762 7.07143 5.80357 7.16738 5.80357 7.28571V10.9286C5.80357 11.5203 6.28331 12 6.875 12C7.46669 12 7.94643 11.5203 7.94643 10.9286V7.28571C7.94643 7.16738 8.04238 7.07143 8.16071 7.07143H11.8036C12.3953 7.07143 12.875 6.59169 12.875 6C12.875 5.40831 12.3953 4.92857 11.8036 4.92857Z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                  <span>Merchant</span>
                </li>
              )}

              {(data?.brandsid ||
                data?.packageid ||
                data?.id ||
                data?.team_id) &&
                navIndex !== 2 ? null : (
                <li
                  className={navIndex === 2 ? Style.active : null}
                  onClick={() => {
                    setNavIndex(2);
                  }}
                >
                  <div className={Style.icon}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="12"
                      viewBox="0 0 13 12"
                      fill="none"
                    >
                      <path
                        d="M11.8036 4.92857H8.16071C8.04238 4.92857 7.94643 4.83262 7.94643 4.71429V1.07143C7.94643 0.479736 7.46669 0 6.875 0C6.28331 0 5.80357 0.479736 5.80357 1.07143V4.71429C5.80357 4.83262 5.70762 4.92857 5.58929 4.92857H1.94643C1.35474 4.92857 0.875 5.40831 0.875 6C0.875 6.59169 1.35474 7.07143 1.94643 7.07143H5.58929C5.70762 7.07143 5.80357 7.16738 5.80357 7.28571V10.9286C5.80357 11.5203 6.28331 12 6.875 12C7.46669 12 7.94643 11.5203 7.94643 10.9286V7.28571C7.94643 7.16738 8.04238 7.07143 8.16071 7.07143H11.8036C12.3953 7.07143 12.875 6.59169 12.875 6C12.875 5.40831 12.3953 4.92857 11.8036 4.92857Z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                  <span> Package</span>
                  {/* {(data?.brandsid || data?.userid  || data?.id)? "Update" : "Create"}  */}
                </li>
              )}
              {(data?.brandsid ||
                data?.packageid ||
                data?.id ||
                data?.team_id) &&
                navIndex !== 3 ? null : (
                <li
                  className={navIndex === 3 ? Style.active : null}
                  onClick={() => {
                    setNavIndex(3);
                  }}
                >
                  <div className={Style.icon}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="12"
                      viewBox="0 0 13 12"
                      fill="none"
                    >
                      <path
                        d="M11.8036 4.92857H8.16071C8.04238 4.92857 7.94643 4.83262 7.94643 4.71429V1.07143C7.94643 0.479736 7.46669 0 6.875 0C6.28331 0 5.80357 0.479736 5.80357 1.07143V4.71429C5.80357 4.83262 5.70762 4.92857 5.58929 4.92857H1.94643C1.35474 4.92857 0.875 5.40831 0.875 6C0.875 6.59169 1.35474 7.07143 1.94643 7.07143H5.58929C5.70762 7.07143 5.80357 7.16738 5.80357 7.28571V10.9286C5.80357 11.5203 6.28331 12 6.875 12C7.46669 12 7.94643 11.5203 7.94643 10.9286V7.28571C7.94643 7.16738 8.04238 7.07143 8.16071 7.07143H11.8036C12.3953 7.07143 12.875 6.59169 12.875 6C12.875 5.40831 12.3953 4.92857 11.8036 4.92857Z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                  <span> Product</span>
                  {/* {(data?.brandsid || data?.packageid  || data?.id)? "Update" : "Create"}  */}
                </li>
              )}
              {(data?.brandsid ||
                data?.packageid ||
                data?.id ||
                data?.team_id) &&
                navIndex !== 4 ? null : (
                <li
                  className={navIndex === 4 ? Style.active : null}
                  onClick={() => {
                    setNavIndex(4);
                  }}
                >
                  <div className={Style.icon}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="12"
                      viewBox="0 0 13 12"
                      fill="none"
                    >
                      <path
                        d="M11.8036 4.92857H8.16071C8.04238 4.92857 7.94643 4.83262 7.94643 4.71429V1.07143C7.94643 0.479736 7.46669 0 6.875 0C6.28331 0 5.80357 0.479736 5.80357 1.07143V4.71429C5.80357 4.83262 5.70762 4.92857 5.58929 4.92857H1.94643C1.35474 4.92857 0.875 5.40831 0.875 6C0.875 6.59169 1.35474 7.07143 1.94643 7.07143H5.58929C5.70762 7.07143 5.80357 7.16738 5.80357 7.28571V10.9286C5.80357 11.5203 6.28331 12 6.875 12C7.46669 12 7.94643 11.5203 7.94643 10.9286V7.28571C7.94643 7.16738 8.04238 7.07143 8.16071 7.07143H11.8036C12.3953 7.07143 12.875 6.59169 12.875 6C12.875 5.40831 12.3953 4.92857 11.8036 4.92857Z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                  <span> Sub product</span>
                  {/* {(data?.leadid || data?.userid  || data?.id)? "Update" : "Create"}  */}
                </li>
              )}
              {(data?.brandsid ||
                data?.packageid ||
                data?.id ||
                data?.team_id) &&
                navIndex !== 5 ? null : (
                <li
                  className={navIndex === 5 ? Style.active : null}
                  onClick={() => {
                    setNavIndex(5);
                  }}
                >
                  <div className={Style.icon}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="12"
                      viewBox="0 0 13 12"
                      fill="none"
                    >
                      <path
                        d="M11.8036 4.92857H8.16071C8.04238 4.92857 7.94643 4.83262 7.94643 4.71429V1.07143C7.94643 0.479736 7.46669 0 6.875 0C6.28331 0 5.80357 0.479736 5.80357 1.07143V4.71429C5.80357 4.83262 5.70762 4.92857 5.58929 4.92857H1.94643C1.35474 4.92857 0.875 5.40831 0.875 6C0.875 6.59169 1.35474 7.07143 1.94643 7.07143H5.58929C5.70762 7.07143 5.80357 7.16738 5.80357 7.28571V10.9286C5.80357 11.5203 6.28331 12 6.875 12C7.46669 12 7.94643 11.5203 7.94643 10.9286V7.28571C7.94643 7.16738 8.04238 7.07143 8.16071 7.07143H11.8036C12.3953 7.07143 12.875 6.59169 12.875 6C12.875 5.40831 12.3953 4.92857 11.8036 4.92857Z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                  <span>Merchant Type</span>
                  {/* {(data?.leadid || data?.userid  || data?.id)? "Update" : "Create"}  */}
                </li>
              )}
              {(data?.brandsid ||
                data?.packageid ||
                data?.id ||
                data?.team_id) &&
                navIndex !== 6 ? null : (
                <li
                  className={navIndex === 6 ? Style.active : null}
                  onClick={() => {
                    setNavIndex(6);
                  }}
                >
                  <div className={Style.icon}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="12"
                      viewBox="0 0 13 12"
                      fill="none"
                    >
                      <path
                        d="M11.8036 4.92857H8.16071C8.04238 4.92857 7.94643 4.83262 7.94643 4.71429V1.07143C7.94643 0.479736 7.46669 0 6.875 0C6.28331 0 5.80357 0.479736 5.80357 1.07143V4.71429C5.80357 4.83262 5.70762 4.92857 5.58929 4.92857H1.94643C1.35474 4.92857 0.875 5.40831 0.875 6C0.875 6.59169 1.35474 7.07143 1.94643 7.07143H5.58929C5.70762 7.07143 5.80357 7.16738 5.80357 7.28571V10.9286C5.80357 11.5203 6.28331 12 6.875 12C7.46669 12 7.94643 11.5203 7.94643 10.9286V7.28571C7.94643 7.16738 8.04238 7.07143 8.16071 7.07143H11.8036C12.3953 7.07143 12.875 6.59169 12.875 6C12.875 5.40831 12.3953 4.92857 11.8036 4.92857Z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                  <span>Teams</span>
                </li>
              )}
              {(data?.brandsid ||
                data?.packageid ||
                data?.id ||
                data?.team_id) &&
                navIndex !== 7 ? null : (
                <li
                  className={navIndex === 7 ? Style.active : null}
                  onClick={() => {
                    setNavIndex(7);
                  }}
                >
                  <div className={Style.icon}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="12"
                      viewBox="0 0 13 12"
                      fill="none"
                    >
                      <path
                        d="M11.8036 4.92857H8.16071C8.04238 4.92857 7.94643 4.83262 7.94643 4.71429V1.07143C7.94643 0.479736 7.46669 0 6.875 0C6.28331 0 5.80357 0.479736 5.80357 1.07143V4.71429C5.80357 4.83262 5.70762 4.92857 5.58929 4.92857H1.94643C1.35474 4.92857 0.875 5.40831 0.875 6C0.875 6.59169 1.35474 7.07143 1.94643 7.07143H5.58929C5.70762 7.07143 5.80357 7.16738 5.80357 7.28571V10.9286C5.80357 11.5203 6.28331 12 6.875 12C7.46669 12 7.94643 11.5203 7.94643 10.9286V7.28571C7.94643 7.16738 8.04238 7.07143 8.16071 7.07143H11.8036C12.3953 7.07143 12.875 6.59169 12.875 6C12.875 5.40831 12.3953 4.92857 11.8036 4.92857Z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                  <span>Team User</span>
                </li>
              )}


              {/* {(data?.brandsid ||
                data?.packageid ||
                data?.id ||
                data?.team_id) &&
                navIndex !== 8 ? null : (
                <li
                  className={navIndex === 8 ? Style.active : null}
                  onClick={() => {
                    setNavIndex(8);
                  }}
                >
                  <div className={Style.icon}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="12"
                      viewBox="0 0 13 12"
                      fill="none"
                    >
                      <path
                        d="M11.8036 4.92857H8.16071C8.04238 4.92857 7.94643 4.83262 7.94643 4.71429V1.07143C7.94643 0.479736 7.46669 0 6.875 0C6.28331 0 5.80357 0.479736 5.80357 1.07143V4.71429C5.80357 4.83262 5.70762 4.92857 5.58929 4.92857H1.94643C1.35474 4.92857 0.875 5.40831 0.875 6C0.875 6.59169 1.35474 7.07143 1.94643 7.07143H5.58929C5.70762 7.07143 5.80357 7.16738 5.80357 7.28571V10.9286C5.80357 11.5203 6.28331 12 6.875 12C7.46669 12 7.94643 11.5203 7.94643 10.9286V7.28571C7.94643 7.16738 8.04238 7.07143 8.16071 7.07143H11.8036C12.3953 7.07143 12.875 6.59169 12.875 6C12.875 5.40831 12.3953 4.92857 11.8036 4.92857Z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                  <span>Status</span>
                </li>
              )} */}

            </ul>
          </div>

          <div
            className={Style.close_btn}
            style={{
              position: "absolute",
              top: "-16px",
              right: "-16px",
            }}
            onClick={() => {
              onClose();
            }}
          >
            <XIcon size={"1em"} />
          </div>
        </div>

        {navIndex === 0 && (
          <>
            <AddUpdateBrand
              open={open}
              onClose={() => onClose()}
              brandData={data}
              onSubmit={onSubmit}
              onError={onError}
              Style={Style}
            />
          </>
        )}
        {navIndex === 1 && (
          <>
            <AddUpdateMerchant
              onClose={() => onClose()}
              onSubmit={onSubmit}
              onError={onError}
              CurrentData={data}
              Style={Style}
            />
          </>
        )}
        {navIndex === 2 && (
          <>
            <AddUpdatePackage
              onClose={() => onClose()}
              packageData={data}
              onSubmit={onSubmit}
              onError={onError}
              Style={Style}
            />
          </>
        )}
        {navIndex === 3 && (
          <>
            <AddUpdateProduct
              onClose={() => onClose()}
              onSubmit={onSubmit}
              onError={onError}
              productData={data}
              Style={Style}
            />
          </>
        )}
        {navIndex === 4 && (
          <>
            <AddUpdateSubProduct
              onClose={() => onClose()}
              onSubmit={onSubmit}
              onError={onError}
              subProductData={data}
              Style={Style}
            />
          </>
        )}
        {navIndex === 5 && (
          <>
            <AddUpdateMerchantType
              onClose={() => onClose()}
              onSubmit={onSubmit}
              onError={onError}
              merchantTypeData={data}
              Style={Style}
            />
          </>
        )}
        {navIndex === 6 && (
          <>
            <AddUpdateTeam
              onClose={() => onClose()}
              onSubmit={onSubmit}
              onError={onError}
              teamData={data}
              Style={Style}
            />
          </>
        )}
        {navIndex === 7 && (
          <>
            <AddUpdateTeamUsers
              onClose={() => onClose()}
              onSubmit={onSubmit}
              onError={onError}
              teamUserData={data}
              Style={Style}
            />
          </>
        )}

        {/* {navIndex === 8 && (
          <>
            <AddStatus
              onClose={() => onClose()}
              onSubmit={onSubmit}
              onError={onError}
              // statusData={data}
              Style={Style}
            />
          </>
        )} */}
      </LeftSidePopupLayout>

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default CompanySettingAddUpdate;
